/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Calculator = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22 2V22H2V2H22ZM11.25 12.75H3.5V20.5H11.25V12.75ZM20.5 12.75H12.75V20.5H20.5V12.75ZM8.96967 13.9697L10.0303 15.0303L8.561 16.5L10.0303 17.9697L8.96967 19.0303L7.5 17.561L6.03033 19.0303L4.96967 17.9697L6.439 16.5L4.96967 15.0303L6.03033 13.9697L7.5 15.439L8.96967 13.9697ZM19 17.25V18.75H14V17.25H19ZM19 14.25V15.75H14V14.25H19ZM11.25 3.5H3.5V11.25H11.25V3.5ZM20.5 3.5H12.75V11.25H20.5V3.5ZM8.25 5L8.249 6.75H10V8.25H8.249L8.25 10H6.75L6.749 8.25H5V6.75H6.749L6.75 5H8.25ZM19 6.75V8.25H14V6.75H19Z"
                        fill={color}
                    />
                </svg>
        );
    };
